// extracted by mini-css-extract-plugin
export var container = "styles-module__container___r4apD";
export var headContainer = "styles-module__headContainer___QnwLy";